<template>
  <div class="component-wrap">
    <AppContentHeader headline="Design Orders">
      <AppInput
        class="filter-orders__field"
        required
        placeholder="Filter by any option"
        v-model="filter"
      />
    </AppContentHeader>

    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>Note</md-dialog-title>

      <md-dialog-content>
        <b>Design note</b>
        <p>{{ noteMessage }}</p>
        <div v-if="referenceField === ''">
          <b>Reference field</b>
          <p>{{ referenceField }}</p>
        </div>
        <div v-if="uploadDescription !== null">
          <b>Upload Description</b>
          <p>{{ uploadDescription }}</p>
        </div>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="showDialog = false"
          >Close</md-button
        >
      </md-dialog-actions>
    </md-dialog>

    <AppSpinner v-if="loadingSpinner" :loading="loadingSpinner" />

    <transition mode="out-in" name="fade">
      <md-tabs class="design-orders-tabs" v-show="!loadingSpinner">
        <md-tab
          id="tab-sponsorships"
          md-label="Sponsorships"
          @click="clickCurrentTab(1)"
        >
          <div class="md-layout md-alignment-top-center">
            <!--                        <OrderCard-->
            <!--                                v-for="order in filteredSponsorships"-->
            <!--                                :key="order.sponsorships_id + '_sponsorships'"-->
            <!--                                :orderData="order"-->
            <!--                                class="md-layout-item md-xlarge-size-30 md-large-size-30 md-medium-size-30 md-small-size-50 md-xsmall-size-100">-->
            <!--                        </OrderCard>-->

            <div style="width: 100%; max-height: 70vh; overflow-y: auto;">
              <table style="width: 100%; border-collapse: collapse;">
                <thead>
                  <tr
                    style="position: sticky; top: 0; background-color: white; z-index: 2;"
                  >
                    <th
                      style="padding: 10px; cursor:pointer"
                      @click="sortSponsorshipsBy('sponsorships_id')"
                    >
                      ID
                    </th>
                    <th style="padding: 10px;">Thumbnail</th>
                    <th
                      style="padding: 10px; cursor:pointer"
                      @click="sortSponsorshipsBy('sponsorship_status_name')"
                    >
                      Status
                    </th>
                    <th
                      style="padding: 10px; cursor:pointer"
                      @click="sortSponsorshipsBy('adspaces_description')"
                    >
                      Adspaces
                    </th>
                    <th
                      style="padding: 10px; cursor:pointer"
                      @click="sortSponsorshipsBy('size')"
                    >
                      Size
                    </th>
                    <th style="padding: 10px;">Download</th>
                    <th style="padding: 10px;">Change Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="order in sortedSponsorships"
                    :key="order.sponsorships_id + '_sponsorships'"
                  >
                    <td style="padding: 10px;">{{ order.sponsorships_id }}</td>
                    <td
                      style="padding: 10px; text-align: center; vertical-align: middle;"
                    >
                      <img
                        @click="GoToOrder(order.sponsorships_id)"
                        v-if="!order.artwork_url_thumbnail"
                        style="width: 120px; height: 120px; object-fit: contain; display: block; margin: 0 auto; background: #f8f8f8; border-radius: 6px; border: 1px solid #eee;"
                        :src="fallbackImage"
                        alt="Fallback Image"
                      />
                      <span
                        v-else
                        style="display: flex; align-items: center; justify-content: center; gap: 8px; max-width: 420px; min-width: 200px; overflow: hidden; margin: 0 auto;"
                      >
                        <span
                          style="display: flex; align-items: center; justify-content: center; width: 120px; height: 120px; background: #f8f8f8; border-radius: 6px; overflow: hidden; border: 1px solid #eee;"
                        >
                          <img
                            @click="GoToOrder(order.sponsorships_id)"
                            style="width: 100%; height: 100%; object-fit: contain; cursor: pointer; display: block;"
                            :src="order.artwork_url_thumbnail"
                            alt="Order Image"
                          />
                        </span>
                        <span
                          v-if="
                            order.backside_artwork_url_thumbnail &&
                              typeof order.backside_artwork_url_thumbnail ===
                                'string' &&
                              order.backside_artwork_url_thumbnail.trim() !== ''
                          "
                          style="display: flex; align-items: center; justify-content: center; width: 120px; height: 120px; background: #f8f8f8; border-radius: 6px; overflow: hidden; border: 1px solid #ccc;"
                        >
                          <img
                            @click="GoToOrder(order.sponsorships_id)"
                            style="width: 100%; height: 100%; object-fit: contain; cursor: pointer; display: block;"
                            :src="order.backside_artwork_url_thumbnail"
                            alt="Backside Image"
                          />
                        </span>
                      </span>
                    </td>
                    <td style="padding: 10px; text-align: center;">
                      {{ order.sponsorship_status_name }}
                    </td>
                    <td style="padding: 10px;">
                      {{ order.adspaces_description }}
                    </td>
                    <td style="padding: 10px;">
                      {{
                        order.size
                          ? order.size
                          : order.width && order.height
                          ? order.width + " x " + order.height
                          : ""
                      }}
                    </td>
                    <td style="padding: 10px;">
                      <md-button
                        class="md-raised md-primary"
                        @click="downloadOrderImages(order, 'sponsorship')"
                      >
                        Download
                      </md-button>
                    </td>
                    <td style="padding: 10px; text-align: center;">
                      <div
                        style="display: flex; justify-content: center; align-items: center;"
                      >
                        <OrderCardStatusesMenu
                          :order="order"
                          :allowed-statuses="[
                            'Downloaded',
                            'Ready to Print',
                            'Preflight Problem',
                          ]"
                          @statusUpdated="onStatusUpdated(1)"
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-if="fetchingData" class="spinner"></div>
          <AppEmptyState
            message="There is no sponsorships to display."
            v-else-if="!fetchingData && !sponsorships.length && !dontShowMsg"
          />
        </md-tab>

        <md-tab
          id="tab-free-standing"
          md-label="Free Standing"
          @click="clickCurrentTab(2)"
        >
          <div class="md-layout md-alignment-top-center">
            <OrderCard
              v-for="(order, index) in freeStanding"
              :key="index + '_freeStanding'"
              class="md-layout-item md-xlarge-size-30 md-large-size-30 md-medium-size-30 md-small-size-50 md-xsmall-size-100"
            >
            </OrderCard>
          </div>

          <AppEmptyState
            message="There is no free standing orders to display."
            v-if="!freeStanding.length && !dontShowMsg"
          />
        </md-tab>

        <md-tab id="tab-signage" md-label="Signage" @click="clickCurrentTab(3)">
          <div class="md-layout md-alignment-top-center">
            <!--                        <OrderCard-->
            <!--                                v-for="order in filteredSignage"-->
            <!--                                :key="order.id + '_signage'"-->
            <!--                                :orderData="order"-->
            <!--                                class="md-layout-item md-xlarge-size-30 md-large-size-30 md-medium-size-30 md-small-size-50 md-xsmall-size-100">-->
            <!--                        </OrderCard>-->

            <div style="width: 100%; max-height: 70vh; overflow-y: auto;">
              <table style="width: 100%; border-collapse: collapse;">
                <thead>
                  <tr
                    style="position: sticky; top: 0; background-color: white; z-index: 2;"
                  >
                    <th
                      style="padding: 10px; cursor:pointer"
                      @click="sortSignageBy('id')"
                    >
                      Order ID
                    </th>
                    <th style="padding: 10px;">Thumbnail</th>
                    <th
                      style="padding: 10px; cursor:pointer"
                      @click="sortSignageBy('status_name')"
                    >
                      Status
                    </th>
                    <th
                      style="padding: 10px; cursor:pointer"
                      @click="sortSignageBy('signage_description')"
                    >
                      Adspaces
                    </th>
                    <th
                      style="padding: 10px; cursor:pointer"
                      @click="sortSignageBy('size')"
                    >
                      Size
                    </th>
                    <th style="padding: 10px;">Download</th>
                    <th style="padding: 10px;">Change Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="order in sortedSignage"
                    :key="order.id + '_signage'"
                  >
                    <td style="padding: 10px;">{{ order.id }}</td>
                    <td
                      style="padding: 10px; text-align: center; vertical-align: middle;"
                    >
                      <img
                        @click="GoToOrder2(order.id)"
                        v-if="!order.upload_thumbnail_url"
                        style="width: 120px; height: 120px; object-fit: contain; display: block; margin: 0 auto; background: #f8f8f8; border-radius: 6px; border: 1px solid #eee;"
                        :src="fallbackImage"
                        alt="Fallback Image"
                      />
                      <span
                        v-else
                        style="display: flex; align-items: center; justify-content: center; gap: 8px; max-width: 420px; min-width: 200px; overflow: hidden; margin: 0 auto;"
                      >
                        <span
                          style="display: flex; align-items: center; justify-content: center; width: 120px; height: 120px; background: #f8f8f8; border-radius: 6px; overflow: hidden; border: 1px solid #eee;"
                        >
                          <img
                            @click="GoToOrder2(order.id)"
                            style="width: 100%; height: 100%; object-fit: contain; cursor: pointer; display: block;"
                            :src="order.upload_thumbnail_url"
                            alt="Order Image"
                          />
                        </span>
                        <span
                          v-if="
                            order.backside_artwork_url_thumbnail &&
                              typeof order.backside_artwork_url_thumbnail ===
                                'string' &&
                              order.backside_artwork_url_thumbnail.trim() !== ''
                          "
                          style="display: flex; align-items: center; justify-content: center; width: 120px; height: 120px; background: #f8f8f8; border-radius: 6px; overflow: hidden; border: 1px solid #ccc;"
                        >
                          <img
                            @click="GoToOrder2(order.id)"
                            style="width: 100%; height: 100%; object-fit: contain; cursor: pointer; display: block;"
                            :src="order.backside_artwork_url_thumbnail"
                            alt="Backside Image"
                          />
                        </span>
                      </span>
                    </td>
                    <td style="padding: 10px; text-align: center;">
                      {{ order.status_name }}
                    </td>
                    <td style="padding: 10px;">
                      {{ order.signage_description }}
                    </td>
                    <td style="padding: 10px;">
                      {{
                        order.size
                          ? order.size
                          : order.width && order.height
                          ? order.width + " x " + order.height
                          : ""
                      }}
                    </td>
                    <td style="padding: 10px;">
                      <md-button
                        class="md-raised md-primary"
                        @click="downloadOrderImages(order, 'signage')"
                      >
                        Download
                      </md-button>
                    </td>
                    <td style="padding: 10px; text-align: center;">
                      <div
                        style="display: flex; justify-content: center; align-items: center;"
                      >
                        <OrderCardStatusesMenu
                          :order="order"
                          :allowed-statuses="[
                            'Downloaded',
                            'Ready to Print',
                            'Preflight Problem',
                          ]"
                          @statusUpdated="onStatusUpdated(3)"
                          @printProblemNote="onPrintProblemNote(order, $event)"
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-if="fetchingData" class="spinner"></div>
          <AppEmptyState
            message="There is no free signage to display."
            v-else-if="!fetchingData && !signage.length && !dontShowMsg"
          />
        </md-tab>
      </md-tabs>
    </transition>

    <md-snackbar
      md-position="center"
      :md-active.sync="snackbar.show"
      :md-duration="snackbar.duration"
      md-persistent
    >
      <span>{{ snackbar.message }}</span>
      <md-button class="md-primary" @click="snackbar.show = false"
        >Got it</md-button
      >
    </md-snackbar>
    <!-- snackbar to show response message -->
  </div>
</template>

<script>
import OrderCard from "@/components/Common/OrderCard";
import { DeepFilterMixin } from "@/mixins/DeepFilterMixin";
import Cookie from "js-cookie";
import OrderCardStatusesMenu from "@/components/Common/OrderCardStatusesMenu.vue";

export default {
  name: "DesignDashboard",
  mixins: [DeepFilterMixin],
  props: {
    cardMode: {
      type: String,
      default: "design",
    },
    orderData: {
      type: Object,
      default: null,
    },
    nextStatuses: {
      type: Object,
      default: null,
    },
  },
  data: function() {
    return {
      fallbackImage:
        document.location.origin +
        require("@/assets/img/empty_state_image.png"),
      dontShowMsg: false,
      sponsorships: [],
      freeStanding: [],
      signage: [],
      tabNumber: 1,
      loadingSpinner: false,
      snackbar: {
        show: false,
        message: "",
        duration: 4000,
      },
      filter: "",
      fetchingData: true,
      showDialog: false,
      noteMessage: null,
      referenceField: "",
      uploadDescription: null,
      headerFilters: {
        id: "",
        status_name: "",
        signage_description: "",
        size: "",
      },
      headerFiltersSponsorships: {
        id: "",
        sponsorship_status_name: "",
        adspaces_description: "",
        size: "",
      },
      sortSponsorships: {
        column: "sponsorships_id",
        direction: 1, // 1 for ascending, -1 for descending
      },
      sortSignage: {
        column: "id",
        direction: 1,
      },
    };
  },
  components: {
    OrderCardStatusesMenu,
    OrderCard,
  },
  created() {
    //EventBus.$on('data-saved', this.loadData(1));
    setTimeout(() => {
      this.loadData(1);
    }, 1000);
    this.getMaterials();
    this.filter = this.$store.getters["getSignageFilter"];
  },

  beforeRouteLeave(to, from, next) {
    this.$store.dispatch("saveSignageFilter", this.filter);
    next();
  },
  computed: {
    sortedSponsorships() {
      let arr = this.sponsorships.filter((x) =>
        this.filterFunction(x, this.filter)
      );
      if (this.sortSponsorships.column) {
        arr = arr.slice().sort((a, b) => {
          let valA = a[this.sortSponsorships.column];
          let valB = b[this.sortSponsorships.column];
          if (typeof valA === "string") valA = valA.toLowerCase();
          if (typeof valB === "string") valB = valB.toLowerCase();
          if (valA === valB) return 0;
          return valA > valB
            ? this.sortSponsorships.direction
            : -this.sortSponsorships.direction;
        });
      }
      return arr;
    },
    sortedSignage() {
      let arr = this.signage.filter((x) => this.filterFunction(x, this.filter));
      if (this.sortSignage.column) {
        arr = arr.slice().sort((a, b) => {
          let valA = a[this.sortSignage.column];
          let valB = b[this.sortSignage.column];
          if (typeof valA === "string") valA = valA.toLowerCase();
          if (typeof valB === "string") valB = valB.toLowerCase();
          if (valA === valB) return 0;
          return valA > valB
            ? this.sortSignage.direction
            : -this.sortSignage.direction;
        });
      }
      return arr;
    },
  },
  methods: {
    async downloadOrderImages(order, type) {
      // Download main image
      let mainUrl =
        type === "sponsorship" ? order.original_url : order.original_url;
      let mainName =
        type === "sponsorship"
          ? `${order.sponsorships_id}#${order.adspaces_description}`
          : `${order.id}#${order.signage_description}`;
      if (mainUrl) {
        await this.downloadFile(mainUrl, mainName);
      }
      // Download artwork thumbnail if exists
      let thumbUrl =
        type === "sponsorship"
          ? order.artwork_url_thumbnail
          : order.upload_thumbnail_url;
      if (thumbUrl && typeof thumbUrl === "string" && thumbUrl.trim() !== "") {
        await this.downloadFile(thumbUrl, mainName + "_thumbnail");
      }
      // Download backside if exists
      if (
        order.backside_artwork_url_thumbnail &&
        typeof order.backside_artwork_url_thumbnail === "string" &&
        order.backside_artwork_url_thumbnail.trim() !== ""
      ) {
        await this.downloadFile(
          order.backside_artwork_url_thumbnail,
          mainName + "_backside"
        );
      }
    },
    async downloadFile(url, filename) {
      try {
        const response = await fetch(url, {
          mode: "cors", // ensure CORS is allowed
        });
        const blob = await response.blob();
        const downloadUrl = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(downloadUrl);
      } catch (error) {
        console.error("Download failed:", error);
        this.showSnackbar("Failed to download file.");
      }
    },
    OpenNote(type, note) {
      if (type === 1) {
        this.noteMessage =
          note.sponsorships_install_notes !== ""
            ? note.sponsorships_install_notes
            : "No message";
        this.referenceField = null;
        this.uploadDescription = null;
      }
      if (type === 2) {
        this.noteMessage = note.notes !== "" ? note.notes : "No message";
        this.referenceField =
          note.reference_field !== "" ? note.reference_field : null;
        this.uploadDescription =
          note.upload_description !== "" ? note.upload_description : null;
      }
      this.showDialog = true;
    },
    onStatusUpdated(tabID) {
      this.loadData(tabID);
      this.$emit("statusUpdated");
    },
    onPrintProblemNote() {
      // TODO: Integrate notification system here
      // For now, just show a snackbar and log
      //this.showSnackbar(`Print Problem note sent`);
      // Here you could call an API or send an email/notification
    },
    GoToOrder(id) {
      this.$router.push(`/design/sponsorship/${id}`);
    },
    GoToOrder2(id) {
      this.$router.push(`/design/signage/${id}`);
    },
    clickCurrentTab(tabNumber) {
      this.dontShowMsg = true;
      this.loadData(tabNumber);
    },
    showSnackbar(message) {
      this.snackbar.message = message;
      this.snackbar.show = true;
    },

    async loadData(tabNumber) {
      this.dontShowMsg = true;
      this.fetchingData = true;

      try {
        if (tabNumber === 1) {
          this.sponsorships = (
            await this.$axios.get(
              `sponsorships?season_id=${Cookie.get("season_id")}&media_id=6`
            )
          ).data;
          this.sponsorships = this.sponsorships.filter(
            (x) => x.sponsorship_status_id !== 40
          );
          this.dontShowMsg = false;
        } else if (tabNumber === 2) {
          // this.freeStanding = (await this.$axios.get('free-standing')).data;
          this.freeStanding = [];
          this.dontShowMsg = false;
        } else {
          this.signage = (
            await this.$axios.get(
              `signage-orders?season_id=${Cookie.get("season_id")}`,
              { params: { current_season: true } }
            )
          ).data;
          this.dontShowMsg = false;
        }

        this.loadingSpinner = false;
        this.fetchingData = false;
      } catch (err) {
        this.loadingSpinner = false;
        this.fetchingData = false;
        // this.showSnackbar(err.message);
      }
    },

    getMaterials() {
      this.$store.dispatch("materials/getMaterials");
    },
    sortSponsorshipsBy(col) {
      if (this.sortSponsorships.column === col) {
        this.sortSponsorships.direction *= -1;
      } else {
        this.sortSponsorships.column = col;
        this.sortSponsorships.direction = 1;
      }
    },
    sortSignageBy(col) {
      if (this.sortSignage.column === col) {
        this.sortSignage.direction *= -1;
      } else {
        this.sortSignage.column = col;
        this.sortSignage.direction = 1;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.design-orders-tabs {
  border: 1px solid rgba($color-black, 0.4);

  /deep/ .md-tabs-navigation {
    @include respond(xsmall) {
      flex-direction: column;
    }

    .md-button {
      @include respond(small) {
        width: 100%;
        max-width: 100%;
      }
    }
  }
}

.spinner {
  margin: 0 auto;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #cd0a2f;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
